import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import CardDropdown from "components/common/CardDropdown";
import FalconPagination from "components/common/custom/pagination";
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import React, { useEffect } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { Eye, Gear, Pen } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { setIndividualData } from "../config/PriceSlice";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import { GetAllPoyer } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import { AddPriceService, GetAllPriceList } from "../config/PriceApi";
import { toast } from "react-toastify";
import moment from "moment";
import SubtleBadge from "components/common/SubtleBadge";

const PriceListTable = ({
  totalRows,
  handlePageChange,
  handlePerRowsChange,
  data,
  page,
  rowsPerPage,
  setting,
}) => {
  const dispatch = useDispatch();
  const { priceFilters } = useSelector((state) => state.price);
  const { poyerList } = useSelector((state) => state.eligibilityCheckList);
  const navigate = useNavigate();
  const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];
  const selectBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  useEffect(() => {
    if (poyerList?.length === 0) {
      dispatch(GetAllPoyer());
    }
  }, [poyerList]);

  const handleEditServicePrice = (row) => {
    dispatch(setIndividualData(row));
    navigate(`${paths.addPriceList}/${row?.price_id}`);
  };

  const handleDeactiveService = async (row) => {
    const payload = {
      price_id: row?.price_id || "",
      status: "Deactive",
      branch_id:
        allBranches?.find((item) => item?.branch_cchino === row?.brcchi)
          ?.branch_id || "",
      payer_id:
        poyerList?.find((item) => item?.payer_name === row?.payer_name)
          ?.payer_id || "",
      nphies_code: row?.nphies_code || "",
      provider_cde: row?.provider_code || "",
      provider_cdedesc: row?.provider_codedesc || "",
      prd_price: row?.unit_price || "",
      prd_disc: row?.price_discount || "",
      prd_tax: row?.price_tax || "",
      actv_dte: row?.activated_date
        ? moment(row?.activated_date).format("YYYY-MM-DD")
        : "" || "",
    };

    const response = await dispatch(AddPriceService(payload)).unwrap();
    if (response?.success) {
      const body = {
        branch_id:
          priceFilters?.branch?.branch_id ||
          selectBranch?.branch_id ||
          selectBranch?.value ||
          "",
        nphies_code: "",
        payer_id: "",
        provider_cde: "",
        is_activate: false,
        start_point: 0,
        limit: 10,
      };

      const res = await dispatch(GetAllPriceList(body)).unwrap();
      if (res?.success) {
        toast.success(response?.message_en);
      }
    } else {
      toast.error(response?.message_en);
    }
  };

  const columns = [
    {
      accessorKey: "index",
      header: "#",
      cell: ({ row }) => (
        <div className="d-flex align-items-center w-100">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "30px", height: "30px" }}
          >
            {page * rowsPerPage + row.index + 1}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "payer",
      header: "Payer ",
      cell: ({ row: { original } }) => `${original?.payer_name || ""}`,
    },
    {
      accessorKey: "nphiescode",
      header: "Nphies Code",
      cell: ({ row: { original } }) => `${original?.nphies_code || ""}`,
    },
    {
      accessorKey: "nphiesdesc",
      header: "Nphies Desc.",
      cell: ({ row: { original } }) => `${original?.nphies_desc || ""}`,
    },
    {
      accessorKey: "providercode",
      header: "Provider Code",
      cell: ({ row: { original } }) => `${original?.provider_code || ""}`,
    },
    {
      accessorKey: "providerdesc",
      header: "Provider  Desc.",
      cell: ({ row: { original } }) => `${original?.provider_codedesc || ""}`,
    },
    {
      accessorKey: "unitprice",
      header: "Unit Price",
      cell: ({ row: { original } }) => `${original?.unit_price || ""}`,
    },
    {
      accessorKey: "discount",
      header: "Discount %",
      cell: ({ row: { original } }) => `${original?.price_discount || ""}`,
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row: { original } }) => {
        const rawStatus = original.status || "";
        const normalizedStatus = rawStatus.replace(/\s+/g, "").toLowerCase();

        const statusConfig = {
          active: {
            bg: "#d9f8eb",
            color: "#00894f",
            icon: "check",
            label: "Active",
          },
          deactive: {
            bg: "#fbdbe1",
            color: "#b82c46",
            icon: "exclamation",
            label: "Deactive",
          },
        };
        const config = statusConfig[normalizedStatus] || {
          bg: "#f8f9fa",
          color: "#000",
          icon: "question",
          label: rawStatus || "Unknown",
        };
        return (
          <div className="d-flex justify-content-start w-100">
            <SubtleBadge
              pill
              style={{
                backgroundColor: config.bg,
                color: config.color,
                border: `1px solid ${config.color}20`,
                width: "110px",
              }}
              className="d-flex flex-center fs-12 p-2 gap-1"
            >
              <FontAwesomeIcon
                icon={config.icon}
                transform="shrink-2"
                className="ms-1 me-1"
              />
              {config.label}
            </SubtleBadge>
          </div>
        );
      },
    },
    {
      accessorKey: "vat",
      header: "Vat % ",
      cell: ({ row: { original } }) => `${original?.price_tax || ""}`,
    },
    {
      accessorKey: "action",
      header: <Gear />,
      cell: ({ row: { original } }) => (
        <>
          {(Number(setting?.edit) === 1 || Number(setting?.delete) === 1) && (
            <CardDropdown icon="ellipsis-v" dropdownClassName="py-2">
              {Number(setting?.edit) === 1 && (
                <Dropdown.Item onClick={() => handleEditServicePrice(original)}>
                  <Pen className="me-2" />
                  Edit
                </Dropdown.Item>
              )}

              {Number(setting?.edit) === 1 && (
                <Dropdown.Item onClick={() => handleDeactiveService(original)}>
                  <FontAwesomeIcon icon="ban" className="me-2" />
                  Deactivate
                </Dropdown.Item>
              )}
            </CardDropdown>
          )}
        </>
      ),
    },
  ];

  const table = useAdvanceTable({
    data,
    columns,
    manualPagination: true,
    pageCount: Math.ceil(totalRows / rowsPerPage),
    state: {
      pagination: {
        pageIndex: page,
        pageSize: rowsPerPage,
      },
    },
  });

  useEffect(() => {
    table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
  }, [page, rowsPerPage]);

  return (
    <div className="mb-3 mt-3 border">
      {data?.length > 0 ? (
        <div>
          <AdvanceTableProvider {...table}>
            <AdvanceTable
              tableProps={{
                size: "sm",
                className: "fs-10 mb-0 overflow-hidden",
                striped: true,
              }}
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
            />
          </AdvanceTableProvider>
          <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
            <FalconPagination
              currentPage={page}
              rowsPerPage={rowsPerPage}
              totalRecords={totalRows}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePerRowsChange}
            />
          </Card.Footer>
        </div>
      ) : (
        <div className="text-center py-3">No Data To Show</div>
      )}
    </div>
  );
};

export default PriceListTable;
